import { Component, OnInit } from '@angular/core';
import {MasterPassService} from '../../../services/master-pass/master-pass.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {SessionService} from '../../../services/session/session.service';
import {TransactionStatus} from '../../../interfaces/transaction/TransactionStatus';
import {Session} from '../../../interfaces/session-data';

@Component({
  selector: 'app-validate',
  templateUrl: './validate.component.html',
  styleUrls: ['./validate.component.scss']
})
export class ValidateComponent implements OnInit {

  pollingCount = 1;
  paymentMethod = 'master_pass';
  paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}.png`;
  loading = true;

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;
  pollingInterval;

  // Countdown
  config = { leftTime: 45, format: 's' };
  public sessionToken: string;
  public transactionUid: string;
  timeout = 45;
  countdownTimer;
  hidePgLogo = false;
  sessionData: Session;
  constructor(private masterPassService: MasterPassService,
              private sessionService: SessionService,
              private router: Router,
              private route: ActivatedRoute) {
    sessionStorage.setItem('selected-payment', 'master_pass');

  }

  navigateToStatus() {
    this.router.navigate(
      [`transaction-status`]);
  }

  ngOnInit(): void {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.hidePgLogo = this.sessionData?.sessionDisplayInformation?.hidePgLogo === 'true';
    this.route.queryParams.subscribe(data => {
      this.sessionToken = data.reference;
    });
    this.countdownTimer = setInterval(() => {
      this.timeout--;
    }, 1000);
    this.beginCountdown();
    this.validateMasterPassTransactionState();

  }

  clearIntervalCustom(interval) {
    clearInterval(interval);
    clearInterval(this.countdownTimer);
    this.navigateToStatus();
  }

  beginCountdown() {

  }

  validateMasterPassTransactionState(){

    this.masterPassService.validateMasterPass(this.sessionToken)
      .subscribe(
        value => {
          this.navigateToStatus();
        },
        error => {
          if (error.status === 425) {
            const interval = 3;
            setTimeout(() => {
              this.clearIntervalCustom(this.pollingInterval);
            }, this.timeout * 1000);
            this.pollingInterval = setInterval(() => {
              this.masterPassService.validateMasterPass(this.sessionToken)
                .subscribe({
                  next: value => this.navigateToStatus()
                });
              if (this.timeout === 0) {
                this.navigateToStatus();
              }
            }, interval * 1000);
          } else {
            this.navigateToStatus();
          }
        }
      );
  }

}
